(() => {
  const API = 'https://os.taile99a1a.ts.net/podapi';
  const SESSION_KEY = 'paw_conversion_session';
  const ATTRIBUTION_KEY = 'paw_conversion_attribution';
  const QA_KEY = 'paw_conversion_qa';
  const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const clean = (value, max = 120) =>
    typeof value === 'string' ? value.replace(/[^\w .:/-]/g, '').slice(0, max) : '';
  const allowed = () => {
    try {
      return !window.Shopify?.customerPrivacy ||
        window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    } catch (_) {
      return false;
    }
  };
  const sessionId = (() => {
    let value = sessionStorage.getItem(SESSION_KEY);
    if (!value) {
      value = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`).slice(0, 64);
      sessionStorage.setItem(SESSION_KEY, value);
    }
    return value;
  })();
  const query = new URLSearchParams(location.search);
  const isQa = query.get('paw_qa') === '1' || sessionStorage.getItem(QA_KEY) === '1';
  if (query.get('paw_qa') === '1') sessionStorage.setItem(QA_KEY, '1');
  // QA runs stay out of Meta unless explicitly verifying the pixel events.
  if (query.get('paw_qa_meta') === '1') sessionStorage.setItem(`${QA_KEY}_meta`, '1');
  const qaMeta = isQa && sessionStorage.getItem(`${QA_KEY}_meta`) === '1';
  const attribution = (() => {
    let stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}'); } catch (_) {}
    const next = { ...stored };
    UTM_FIELDS.forEach((field) => {
      const value = clean(query.get(field));
      if (value) next[field] = value;
    });
    if (Object.keys(next).length) {
      sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(next));
    }
    return next;
  })();
  const pageLane = document.body?.dataset.pawPageLane || 'browse';
  const pageProduct = document.body?.dataset.pawProductHandle || '';
  // The Facebook & Instagram app pixel only forwards Shopify's standard
  // events, so preview funnel events are sent to the same pixel from here.
  // When the app has already created fbq (it initialises this pixel on the
  // page) it is reused untouched; otherwise a page pixel is initialised with
  // autoConfig off and no PageView, so it only carries the events below.
  const META_PIXEL_ID = '1711075213346731';
  const META_EVENTS = {
    preview_started: 'PreviewStarted',
    artwork_ready: 'PreviewReady',
    mockup_verified: 'PreviewReady',
  };
  const marketingAllowed = () => {
    try {
      return !window.Shopify?.customerPrivacy ||
        window.Shopify.customerPrivacy.marketingAllowed();
    } catch (_) {
      return false;
    }
  };
  const metaPixel = () => {
    if (!window.fbq) {
      metaPixel.owned = true;
      const fbq = window.fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    if (metaPixel.owned && !metaPixel.ready) {
      window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
      window.fbq('init', META_PIXEL_ID);
      metaPixel.ready = true;
    }
    return window.fbq;
  };
  let previewReadySent = false;
  let previewStyle = '';
  const trackMeta = (event, metadata) => {
    const name = META_EVENTS[event];
    if (!name || (isQa && !qaMeta) || !marketingAllowed()) return;
    if (event === 'preview_started') {
      previewReadySent = false;
      previewStyle = clean(metadata.style || '', 60);
    }
    if (name === 'PreviewReady') {
      if (previewReadySent) return;
      previewReadySent = true;
    }
    try {
      metaPixel()('trackSingleCustom', META_PIXEL_ID, name, {
        content_name: clean(metadata.productHandle || pageProduct),
        lane: clean(metadata.lane || pageLane, 40),
        style: clean(metadata.style || '', 60) || previewStyle,
        traffic_type: isQa ? 'qa' : 'customer',
      });
    } catch (_) {}
  };
  const track = (event, metadata = {}) => {
    trackMeta(event, metadata);
    if (isQa || !allowed()) return Promise.resolve(false);
    const payload = {
      event,
      sessionId,
      lane: metadata.lane || pageLane,
      path: location.pathname,
      productHandle: metadata.productHandle || pageProduct,
      metadata: Object.fromEntries(Object.entries({ ...attribution, ...metadata })
        .filter(([key]) => !['lane', 'productHandle'].includes(key))
        .slice(0, 12)),
      occurredAt: new Date().toISOString(),
    };
    return fetch(`${API}/api/storefront-events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).then((response) => response.ok).catch(() => false);
  };
  const persistCartAttribution = () => {
    if (!allowed()) return Promise.resolve(false);
    const attributes = {
      _paw_session: isQa ? `qa-${sessionId}`.slice(0, 64) : sessionId,
      _paw_traffic_type: isQa ? 'qa' : 'customer',
    };
    UTM_FIELDS.forEach((field) => {
      if (attribution[field]) attributes[`_paw_${field}`] = attribution[field];
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes }),
      keepalive: true,
    }).then((response) => response.ok).catch(() => false);
  };
  window.PawConversion = { track, persistCartAttribution, attribution, isQa };
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-paw-track]');
    if (target) {
      track(target.dataset.pawTrack, {
        lane: target.dataset.pawLane,
        productHandle: target.dataset.pawProduct,
        location: target.dataset.pawLocation || '',
      });
    }
    const checkout = event.target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
    );
    if (checkout) {
      track('checkout_started', { location: location.pathname });
      persistCartAttribution();
    }
  });
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add' || !event.promise) return;
    Promise.resolve(event.promise).then((result) => {
      if (result?.detail?.didError) return;
      track('product_added', { kind: 'standard' });
      persistCartAttribution();
    }).catch(() => {});
  });
  if (location.pathname === '/cart') track('cart_viewed');
  track('storefront_viewed');
})();
